const PAINS = [
  {
    title: "Slow follow-up",
    body: "Leads wait hours — sometimes days — for a reply. By then they've already called the next business.",
  },
  {
    title: "Missed leads",
    body: "Calls after hours, form fills that sit in an inbox, DMs nobody checks. Revenue walking out the door.",
  },
  {
    title: "Too much manual admin",
    body: "Copying data between tools, chasing status updates, re-typing quotes. The business runs you, not the other way around.",
  },
  {
    title: "Disconnected tools",
    body: "CRM, inbox, calendar, spreadsheets — none of them talk to each other, so nothing is ever the full picture.",
  },
  {
    title: "Inconsistent customer comms",
    body: "Some customers get fast, professional replies. Others get radio silence. Quality depends on who's on shift.",
  },
  {
    title: "No visibility",
    body: "You can feel things are slipping, but you can't point to exactly where leads, time or money are leaking.",
  },
];

export default function PainPoints() {
  return (
    <section
      className="relative bg-zinc-950 text-white overflow-hidden"
      data-testid="painpoints-section"
    >
      <div className="absolute inset-0 bg-grid-dark opacity-40 pointer-events-none" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 reveal">
              <span className="inline-block h-px w-10 bg-orange-500" />
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-orange-500 font-semibold">
                The Usual Suspects
              </span>
            </div>
            <h2
              className="mt-6 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight reveal"
              data-testid="painpoints-heading"
            >
              If one of these sounds like your week, you have a bottleneck.
            </h2>
            <p className="mt-6 text-zinc-400 text-lg leading-relaxed max-w-md reveal">
              Most small businesses don't have an AI problem. They have an operations problem
              that AI and automation can quietly fix in the background.
            </p>
          </div>

          <div className="lg:col-span-7">
            <ul className="divide-y divide-zinc-800 border-y border-zinc-800">
              {PAINS.map((p, i) => (
                <li
                  key={p.title}
                  className="group grid grid-cols-[auto_1fr] gap-6 py-6 sm:py-7 reveal"
                  data-testid={`painpoint-${i}`}
                >
                  <span className="font-mono text-sm text-orange-500 pt-1 tabular-nums">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-display font-semibold text-xl sm:text-2xl text-white tracking-tight">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-zinc-400 leading-relaxed max-w-2xl">{p.body}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
